import {
  ADD_PHONE_WITH_MASK,
  ADD_CHECKOUT_UID,
  ADD_VERIFICATION_CODE,
  INITIALIZE,
  PAY_FREQUENCY_LOOKUP,
  CONFIRM_PRICE_TAG_DISCLOSURE,
  CONFIRM_LEASE_AGREEMENT,
  CONFIRM_AON_AGREEMENT,
  CONFIRM_KPLUS_ACKNOWLEDGEMENT,
  CONFIRM_KPLUS_AGREEMENT,
  IS_AON_FLOW,
  ADD_USER_ID,
  CONFIRM_WARRANTY_AGREEMENT,
  ADD_CHECKOUT_ALL,
  ADD_PAY_FREQUENCY,
  ERROR,
  CHANGE_ROUTE,
  CHECKOUT_DECISION,
  SETUP_VWO,
  GET_VWO_DECISION,
  TRACK_VWO_FINAL,
  ADD_VWO_DECISION,
  CHANGE_FEATURE_LINEAR_FLOW,
  SETUP_FEATURE_GATES,
  SETUP_TOKEN,
  SETUP_SYNCHRONY_FLOW,
  ADD_SYNCHRONY_PHONE_CHANGED,
  SETUP_SHOPIFY_FLOW,
  SET_DEDGE_TOKEN,
  SET_NEW_USER_FLOW,
  SET_RETURN_USER_FLOW,
  ADD_NEW_USER_DETAILS,
  CHECKOUT_LOOKUP_DATA,
  ADD_RESOLVE_REDIRECT_URL,
  SET_SHOPIFY_SESSION_ID,
  SET_SHOPIFY_ORG_ID,
  SET_OFFER_PAGE_FLOW,
  SET_INSTORE_VCC_FLOW,
  ADD_AARONS_REFERRAL,
  ADD_IN_STORE_CART_ITEM,
  UPDATE_IN_STORE_CART_ITEM,
  REMOVE_IN_STORE_CART_ITEM,
} from './actionTypes';
import phoneUnmask from '../helpers/phoneUnMask';
// eslint-disable-next-line import/prefer-default-export
export const addPhoneWithMask = phone => ({
  type: ADD_PHONE_WITH_MASK,
  payload: { phone, unmaskedPhone: phoneUnmask(phone) },
});
export const initParameters = initialize => ({ type: INITIALIZE, payload: initialize });
export const sendError = payload => ({ type: ERROR, payload });
export const confirmPriceTagDisclosure = () => ({ type: CONFIRM_PRICE_TAG_DISCLOSURE, payload: true });
export const confirmLeaseAgreement = () => ({ type: CONFIRM_LEASE_AGREEMENT, payload: true });
export const confirmAonAgreement = payload => ({ type: CONFIRM_AON_AGREEMENT, payload });
export const confirmKplusAcknowledgement = () => ({ type: CONFIRM_KPLUS_ACKNOWLEDGEMENT, payload: true });
export const confirmKplusAgreement = payload => ({ type: CONFIRM_KPLUS_AGREEMENT, payload });
export const addIsAonFlow = payload => ({ type: IS_AON_FLOW, payload });
export const addUserId = payload => ({ type: ADD_USER_ID, payload });
export const confirmWarrantyAgreement = () => ({ type: CONFIRM_WARRANTY_AGREEMENT, payload: true });
export const addPayFrequencyLookup = payload => {
  return { type: PAY_FREQUENCY_LOOKUP, payload };
};
export const addVerificationCode = payload => ({ type: ADD_VERIFICATION_CODE, payload });
export const addPayFrequency = payload => ({ type: ADD_PAY_FREQUENCY, payload });
export const addVerificationCheckoutUid = payload => ({ type: ADD_CHECKOUT_UID, payload });
export const addCheckoutAll = payload => ({ type: ADD_CHECKOUT_ALL, payload });
export const checkoutDecision = payload => ({ type: CHECKOUT_DECISION, payload });
export const changeRoute = payload => ({ type: CHANGE_ROUTE, payload });
export const setupVwo = payload => ({ type: SETUP_VWO, payload });
export const getVwoDecision = payload => ({ type: GET_VWO_DECISION, payload });
export const addVwoDecision = payload => ({ type: ADD_VWO_DECISION, payload });
export const trackVwoFinal = payload => ({ type: TRACK_VWO_FINAL, payload });
export const changeFeatureLinearFlow = payload => ({ type: CHANGE_FEATURE_LINEAR_FLOW, payload });
export const setupFeatureGates = payload => ({ type: SETUP_FEATURE_GATES, payload });
export const setupToken = payload => ({ type: SETUP_TOKEN, payload });
export const setSynchronyFlow = payload => ({ type: SETUP_SYNCHRONY_FLOW, payload });
export const addSynchronyPhoneChanged = payload => ({ type: ADD_SYNCHRONY_PHONE_CHANGED, payload });
export const setShopifyFlow = payload => ({ type: SETUP_SHOPIFY_FLOW, payload });
export const setdEdgeToken = payload => ({ type: SET_DEDGE_TOKEN, payload });
export const setNewUserFlow = payload => ({ type: SET_NEW_USER_FLOW, payload });
export const setReturnUserFlow = payload => ({ type: SET_RETURN_USER_FLOW, payload });
export const addNewUserDetails = payload => ({ type: ADD_NEW_USER_DETAILS, payload });
export const addResolveRedirectUrl = payload => ({ type: ADD_RESOLVE_REDIRECT_URL, payload });
export const setCheckoutLookupData = payload => ({ type: CHECKOUT_LOOKUP_DATA, payload });
export const setShopifySessionId = payload => ({ type: SET_SHOPIFY_SESSION_ID, payload });
export const setOfferPageFlow = payload => ({ type: SET_OFFER_PAGE_FLOW, payload });
export const setInstoreVccFlow = payload => ({ type: SET_INSTORE_VCC_FLOW, payload });
export const setShopifyOrgId = payload => ({ type: SET_SHOPIFY_ORG_ID, payload });
export const addAaronsReferral = payload => ({ type: ADD_AARONS_REFERRAL, payload });

let inStoreCartItemSeq = 0;
// Shopper-entered items can share a name, so each gets its own id here rather than in
// the reducer, which keeps the reducer pure.
export const addInStoreCartItem = item => {
  inStoreCartItemSeq += 1;
  return {
    type: ADD_IN_STORE_CART_ITEM,
    payload: { id: `in-store-${Date.now()}-${inStoreCartItemSeq}`, ...item },
  };
};
export const updateInStoreCartItem = (id, changes) => ({
  type: UPDATE_IN_STORE_CART_ITEM,
  payload: { id, changes },
});
export const removeInStoreCartItem = id => ({ type: REMOVE_IN_STORE_CART_ITEM, payload: { id } });
